<script>
	import { onMount } from "svelte";
	import { _ } from "svelte-i18n";

	import Router, { push } from "svelte-spa-router";
	import { wrap } from "svelte-spa-router/wrap";

	import Settings from "./configurator/Settings.svelte";
	import Contact from "./configurator/Contact.svelte";
	import Preview from "./configurator/Preview.svelte";

	import data from "./data.json";
	import { settings, defaults as defaultSettings } from "src/settings.store";
	import { contact, defaults as defaultContact } from "src/contact.store";

	import { camelToSnakeCase } from "src/utility/misc";
	import http from "src/utility/http";

	export let config;

	const routes = {
		"/": wrap({
			component: Settings,
			props: { data }
		}),
		"/contact": Contact,
	}

	const navigate = async ({ detail: routeName }) => {
		push(`/${routeName}`);
	}

	const handleSubmit = async () => {
		const request = { contact: {}, settings: {} };
		for (var item in $contact) {
			request.contact[camelToSnakeCase(item)] = $contact[item];
		}
		for (var item in $settings) {
			request.settings[camelToSnakeCase(item)] = $settings[item];
		}

		await http.sendContact(request);
		$settings = { ...defaultSettings };
		$contact = { ...defaultContact };
		navigate({ detail: "" });
	};

	onMount(() => { 
		navigate({ detail: "" });
		http.setEndpoint(config.endpoint);
	});
</script>

<div class="pc__app">
	<form class="pc__form" on:submit|preventDefault={handleSubmit}>
		<Router {routes} on:routeEvent={navigate} />
	</form>
	<Preview iconPath={config.icons} />
</div>